import { ProductType } from '~/composables/checkout'
import { BroadcastMessage } from '~/utils/broadcaster'

type ClearMyOrdersCacheOptions = {
  broadcast?: boolean
  productType?: ProductType
}

export const useApolloCache = () => {
  const apollo = useNuxtApp().$apollo

  const clearMyOrdersCache = ({
    broadcast = false,
    productType,
  }: ClearMyOrdersCacheOptions = {}) => {
    switch (productType) {
      case ProductType.Lottery:
        return clearSingleOrdersCache(broadcast)
      case ProductType.LotterySubscription:
        return clearSubscriptionOrdersCache(broadcast)
      case ProductType.Scratchcard:
        return clearScratchcardOrdersCache(broadcast)
      default:
        clearScratchcardOrdersCache(broadcast)
        clearSingleOrdersCache(broadcast)
        clearSubscriptionOrdersCache(broadcast)
    }
  }

  const clearActiveAnnouncementsCache = (broadcast = false) => {
    if (broadcast) notifyTabs(BroadcastMessage.ClearActiveAnnouncementsCache)

    apollo.clients.default.cache.evict({
      fieldName: 'activeAnnouncement',
    })
    apollo.clients.default.cache.gc()
  }

  const clearDefaultTeasersCache = (broadcast = false) => {
    if (broadcast) notifyTabs(BroadcastMessage.ClearDefaultTeasersCache)

    apollo.clients.default.cache.evict({
      fieldName: 'defaultTeasers',
    })
    apollo.clients.default.cache.gc()
  }

  const clearResultsCache = (broadcast = false) => {
    if (broadcast) notifyTabs(BroadcastMessage.ClearResultsCache)

    apollo.clients.default.cache.evict({
      fieldName: 'drawListByDay',
    })
    apollo.clients.default.cache.gc()
  }

  const clearScratchcardOrdersCache = (broadcast = false) => {
    if (broadcast) notifyTabs(BroadcastMessage.ClearScratchcardOrdersCache)

    apollo.clients.default.cache.evict({
      fieldName: 'scratchcardOrders',
    })
    apollo.clients.default.cache.gc()
  }

  const clearSingleOrdersCache = (broadcast = false) => {
    if (broadcast) notifyTabs(BroadcastMessage.ClearSingleOrdersCache)

    apollo.clients.default.cache.evict({
      fieldName: 'playSlipOrders',
    })
    apollo.clients.default.cache.gc()
  }

  const clearSubscriptionOrdersCache = (broadcast = false) => {
    if (broadcast) notifyTabs(BroadcastMessage.ClearSubscriptionOrdersCache)

    apollo.clients.default.cache.evict({
      fieldName: 'subscriptionsMultipleLines',
    })
    apollo.clients.default.cache.gc()
  }

  const clearTeasersCache = (broadcast = false) => {
    if (broadcast) notifyTabs(BroadcastMessage.ClearTeasersCache)

    apollo.clients.default.cache.evict({
      fieldName: 'teasers',
    })
    apollo.clients.default.cache.gc()
  }

  const clearTransactionsCache = (broadcast = false) => {
    if (broadcast) notifyTabs(BroadcastMessage.ClearTransactionsCache)

    apollo.clients.default.cache.evict({
      fieldName: 'transactionHistory',
    })
    apollo.clients.default.cache.gc()
  }

  const notifyTabs = (message: BroadcastMessage) => {
    broadcaster.postMessage(message)
  }

  return {
    clearActiveAnnouncementsCache,
    clearDefaultTeasersCache,
    clearMyOrdersCache,
    clearResultsCache,
    clearScratchcardOrdersCache,
    clearSingleOrdersCache,
    clearSubscriptionOrdersCache,
    clearTeasersCache,
    clearTransactionsCache,
  }
}
